import { useEffect, useState } from "react";
import { API_URL } from "./api";

//CHARGEMENT DE TOUS LES ÉVÈNEMENTS (accueil, page Évènements, détail)
//Affichage immédiat avec ceux gardés en mémoire par le navigateur, puis mise à jour avec l'API.
//Si l'API est injoignable, on garde ceux déjà en mémoire.
export default function useEvents() {

  const [events, setEvents] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("allEvents")) || [];
    } catch (error) {
      return [];
    }
  });

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const data = await fetch(`${API_URL}/eventRoute/loadAllEvents`);
        const body = await data.json();
        setEvents(body);
        localStorage.setItem("allEvents", JSON.stringify(body));
      } catch (error) {
        //API injoignable : on garde les évènements déjà en mémoire
      }
    };
    loadEvents();
  }, []);

  return events;
}
